export interface CategoryShortcut {
  type: 'movie' | 'tv' | 'variety';
  label: string;
  englishLabel: string;
  description: string;
  icon: string;
  image: string;
}

export const categoryShortcuts: CategoryShortcut[] = [
  {
    type: 'movie',
    label: '电影',
    englishLabel: 'Movies',
    description: '院线佳作与口碑经典',
    icon: 'ri-film-line',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20film%20concept%20image%2C%20dark%20green%20cinema%20hall%20with%20glowing%20screen%2C%20atmospheric%2C%20minimal%2C%20no%20text&width=600&height=400&seq=sgv-c01&orientation=landscape',
  },
  {
    type: 'tv',
    label: '电视剧',
    englishLabel: 'TV Series',
    description: '热播剧集持续追更',
    icon: 'ri-live-line',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20cozy%20living%20room%20with%20tv%20glow%20at%20night%2C%20warm%20tones%2C%20atmospheric%2C%20minimal%2C%20no%20text&width=600&height=400&seq=sgv-c02&orientation=landscape',
  },
  {
    type: 'variety',
    label: '综艺',
    englishLabel: 'Variety',
    description: '轻松解压快乐加倍',
    icon: 'ri-mic-line',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20colorful%20variety%20show%20stage%20with%20confetti%20and%20lights%2C%20bright%20festive%2C%20minimal%2C%20no%20text&width=600&height=400&seq=sgv-c03&orientation=landscape',
  },
];